
export function percentageFormat(num: number | undefined, lang = 'hr') {
    return num?.toLocaleString(lang, {
        style: 'percent',
    });
}

export function fixedFormat(num: number | undefined, lang = 'hr', fixed = 2) {
    return num?.toLocaleString(lang, {
        minimumFractionDigits: fixed,
        maximumFractionDigits: fixed,
    });
}

export function currencyFormat(num: number | undefined, lang = 'hr', currency = 'EUR') {
    return num?.toLocaleString(lang, {
        style: 'currency',
        currency,
    });
}
